/**
 * Where the agent and the user pool are. Written next to the bundle as `/config.json` by
 * `just ui-deploy` (production) or served from `public/config.json` (local dev), so the
 * bundle itself carries no environment.
 */
export type UiConfig = {
  readonly region: string
  readonly runtimeArn: string
  readonly userPoolId: string
  readonly userPoolClientId: string
}

export async function loadUiConfig(): Promise<UiConfig> {
  const response = await fetch('/config.json', { cache: 'no-store' })
  if (!response.ok) throw new Error(`config.json: ${response.status}`)
  const config = (await response.json()) as Partial<UiConfig>
  for (const key of ['region', 'runtimeArn', 'userPoolId', 'userPoolClientId'] as const) {
    if (!config[key]) throw new Error(`config.json: missing ${key}`)
  }
  return config as UiConfig
}

/** The AG-UI endpoint of a runtime, as the AWS docs spell it. */
export function invocationsUrl(config: UiConfig): string {
  const arn = encodeURIComponent(config.runtimeArn)
  return `https://bedrock-agentcore.${config.region}.amazonaws.com/runtimes/${arn}/invocations?qualifier=DEFAULT`
}
